var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'Home')?_c('div',{staticClass:"app_banner"},[_c('img',{staticStyle:{"width":"100%","max-width":"800px"},attrs:{"src":require("@/assets/img/banner.png")}})]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }